import React, { useEffect, useState } from 'react';
import { useLocation, Link } from 'react-router-dom';
import styled from 'styled-components';
import queryString from 'query-string';

const StyledContainer = styled.div`
  margin-top: 20px;
  align-self: flex-start;
`;

function Feedback() {
  const { pageType, email } = useFeedbackState();

  if (pageType === 'register-mandant-done') {
    return (
      <StyledContainer>
        <div>
          Prima, Du hast Dich erfolgreich mit Deiner Organisation registriert!
          Wir haben Dir eine E-Mail an <b>{email}</b> geschickt. Bestätige sie
          jetzt, um loszulegen (schaue bitte auch in Deinem Spamfilter nach).
        </div>
        <br />
        <div>
          Solltest Du nach 60 Minuten noch keine E-Mail erhalten haben, schreibe
          bitte eine E-Mail an contact@kursifant.com oder chatte mit mir auf{' '}
          <a
            href='https://kursifant.com/'
            rel='noopener noreferrer'
            target='_blank'>
            kursifant.com
          </a>
          .
        </div>
        <br />
        <div>Du kannst dieses Fenster nun schließen.</div>
      </StyledContainer>
    );
  }

  if (pageType === 'register-at-mandant-done') {
    return (
      <StyledContainer>
        <div>
          Prima, Du hast Dich erfolgreich registriert! Wir haben Dir eine E-Mail
          an <b>{email}</b> geschickt. Bestätige sie jetzt, um loszulegen
          (schaue bitte auch in Deinem Spamfilter nach).
        </div>
        <br />
        <div>
          Solltest Du nach 60 Minuten noch keine E-Mail erhalten haben, schreibe
          bitte eine E-Mail an contact@kursifant.com oder chatte mit mir auf{' '}
          <a
            href='https://kursifant.com/'
            rel='noopener noreferrer'
            target='_blank'>
            kursifant.com
          </a>
          .
        </div>
        <br />
        <div>Du kannst dieses Fenster nun schließen.</div>
      </StyledContainer>
    );
  }

  if (pageType === 'initiate-password-reset') {
    return (
      <StyledContainer>
        <div>
          Wir haben Dir eine E-Mail an <b>{email}</b> geschickt. Öffne den
          Bestätigungslink, um dein Passwort zurückzusetzen.
        </div>
        <br />
        <div>Du kannst dieses Fenster nun schließen.</div>
        <br />
        <div>
          Klicke <Link to={`/login`}>hier</Link>, um zur Anmeldung zu gelangen.
        </div>
      </StyledContainer>
    );
  }

  if (pageType === 'reset-token-error') {
    return (
      <StyledContainer>
        <div>Dieser Link ist ungültig oder wurde bereits benutzt.</div>
        <br />
        <div>
          Klicke <Link to={`/login`}>hier</Link>, um zur Anmeldung zu gelangen.
        </div>
      </StyledContainer>
    );
  }

  if (pageType === 'reset-token-success') {
    return (
      <StyledContainer>
        <div>Du hast dein Passwort erfolgreich geändert.</div>
        <br />
        <div>
          Klicke <Link to={`/login`}>hier</Link>, um zur Anmeldung zu gelangen.
        </div>
      </StyledContainer>
    );
  }

  if (pageType === 'resend-activation-link') {
    return (
      <StyledContainer>
        <div>
          Eine E-Mail zum Bestätigen Deiner Adresse wurde nochmals an{' '}
          <b>{email}</b> geschickt. Bestätige sie jetzt, um loszulegen (schaue
          bitte auch in Deinem Spamfilter nach).
        </div>
        <br />
        <div>
          Solltest Du nach 60 Minuten noch keine E-Mail erhalten haben, schreibe
          bitte eine E-Mail an contact@kursifant.com oder chatte mit mir auf{' '}
          <a
            href='https://kursifant.com/'
            rel='noopener noreferrer'
            target='_blank'>
            kursifant.com
          </a>
          .
        </div>
        <br />
        <div>Du kannst dieses Fenster nun schließen.</div>
      </StyledContainer>
    );
  }

  if (pageType === 'account-activation-success') {
    return (
      <StyledContainer>
        <div>Dein Account wurde erfolgreich aktiviert.</div>
        <br />
        <div>
          Klicke <Link to={`/login`}>hier</Link>, um zur Anmeldung zu gelangen.
        </div>
      </StyledContainer>
    );
  }
  if (pageType === 'activation-token-not-found') {
    return (
      <StyledContainer>
        <div>
          Dieser Account wurde bereits aktiviert oder der aufgerufene Link ist
          ungültig.
        </div>
        <br />
        <div>
          Klicke <Link to={`/login`}>hier</Link>, um zur Anmeldung zu gelangen.
        </div>
      </StyledContainer>
    );
  }

  return null;
}

function useFeedbackState() {
  const location = useLocation();
  const [pageType, setPageType] = useState(null);
  const [email, setEmail] = useState(null);

  useEffect(() => {
    const parsed = queryString.parse(location.search);
    if (parsed && parsed.type === 'registerOrganisation' && parsed.email) {
      setPageType('register-mandant-done');
      setEmail(parsed.email);
    }

    if (parsed && parsed.type === 'registerAtOrganisation' && parsed.email) {
      setPageType('register-at-mandant-done');
      setEmail(parsed.email);
    }

    if (parsed && parsed.type === 'initiatePasswordReset' && parsed.email) {
      setPageType('initiate-password-reset');
      setEmail(parsed.email);
    }
    if (parsed && parsed.type === 'resetTokenError') {
      setPageType('reset-token-error');
    }
    if (parsed && parsed.type === 'resetTokenSuccess') {
      setPageType('reset-token-success');
    }
    if (parsed && parsed.type === 'resendActivationLink' && parsed.email) {
      setPageType('resend-activation-link');
      setEmail(parsed.email);
    }
    if (parsed && parsed.type === 'accountActivationSuccess') {
      // In use bei emailInvite
      setPageType('account-activation-success');
    }
    if (parsed && parsed.type === 'activationTokenNotFound') {
      // In use bei emailInvite
      setPageType('activation-token-not-found');
    }
  }, [location.search]);

  // console.log({ pageType, email });

  return { pageType, email };
}

export default Feedback;
